import React from 'react';

// Who a printed document is for (facturas, notas, cotizaciones, conduces), laid out across the page so it takes two
// lines instead of five: the label, the name and the RNC / cédula on one, the address and contact on the other.
// Same layout as the PDF (backend/services/documentPdf.js, ".invoice-bill-to") — change both together.
const ClientBlock = ({ label, client = {}, address }) => {
  const id = client.rnc ? `RNC: ${client.rnc}` : client.cedula ? `Cédula: ${client.cedula}` : 'Consumidor Final';
  const details = [address && address.replace(/\s*\n\s*/g, ', '), client.email, client.phone].filter(Boolean).join(' · ');
  return (
    <div className="invoice-bill-to invoice-client">
      <div>
        <span className="label">{label}</span>
        <span style={{ fontWeight: 700 }}>{client.name}</span>
        <span> · {id}</span>
      </div>
      {details && <div className="invoice-client-details">{details}</div>}
    </div>
  );
};

export default ClientBlock;
